<style lang="less">
@import "./index.less";
</style>

<template>
  <div class="login-container flex col">
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            class="login-form"
            auto-complete="off"
            label-position="left"
          >
            <div class="login-form-box" :style="{'background-color': newWorld ? '#fbe7ed' : '#ffffff'}">
              <img
                v-if="!newWorld"
                :src="logoUrl"
                style="width: 70%;margin-bottom: 20px;"
              />
              <div class="title-container" style="margin-bottom: 20px;">
                <h4 class="title-text">{{loginMethodName}}</h4>
                <span class="login-type" v-if="loginForm.loginType==='mobile'" @click="changeType('email')">邮箱登录</span>
                <span class="login-type"  v-if="loginForm.loginType==='email'" @click="changeType('mobile')">企业员工手机号登录</span>
              </div>
              <!--              邮箱登陆-->
              <div v-if="loginForm.loginType === 'email'">
                <el-form-item prop="email">
                  <el-input
                    v-model="loginForm.email"
                    placeholder="请输入邮箱"
                    name="email"
                    type="text"
                    @change='inputChange'
                    auto-complete="off"
                  />
                </el-form-item>
                <el-form-item prop="dynamicCode">
                  <div class="flex row">
                    <el-input
                    class="flex flex-1"
                      style="margin-right: 5px;"
                      type="text"
                      v-model="loginForm.dynamicCode"
                      placeholder="请输入验证码"
                      name="dynamicCode"
                      auto-complete="off"
                      @keyup.enter.native="login"
                    />
                    <el-button
                      :disabled="!dynamicCode.canClick"
                      :type="newWorld? 'danger' : 'primary'"
                      class="square-btn"
                      @click.native.prevent="sendCode"
                    >
                      {{dynamicCode.buttonText}}
                    </el-button>
                  </div>
                </el-form-item>
                <el-form-item v-if="activityList&&activityList.length">
                    <el-select v-model="currentActivity" style="width: 100%" @change="activityChange" placeholder="活动列表">
                      <el-option
                        v-for="item in activityList"
                        :key="item.id"
                        :label="item.activityName"
                        :value="item.id">
                      </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="isAgreement">
                  <div class="agreement">
                    <img class="agreement__icon pointer" :src="loginForm.isAgreement ? checkboxSelected : checkbox" @click="handleCheckbox" />
                    <div class="pointer" @click="onToAgreement">
                      我已阅读并同意<span class="link">《隐私权政策》</span>
                    </div>
                  </div>
                </el-form-item>
                <el-button
                  :loading="loading"
                  :type="newWorld? 'danger' : 'primary'"
                  class="green-btn"
                  style="width:100%;font-size: 18px"
                  @click.native.prevent="login"
                >
                  登 录
                </el-button>
              </div>
              <!--              手机号登陆-->
              <div v-if="loginForm.loginType === 'mobile'">
                <el-form-item prop="mobile">
                  <el-input
                    v-model="loginForm.mobile"
                    placeholder="请输入手机号"
                    name="mobile"
                    type="text"
                    @change='inputChange'
                    auto-complete="off"
                  />
                </el-form-item>
                <el-form-item prop="dynamicCode">
                  <div class="flex row">

                    <el-input
                      class="flex flex-1"
                      style="margin-right: 5px;"
                      type="text"
                      v-model="loginForm.dynamicCode"
                      placeholder="请输入验证码"
                      name="dynamicCode"
                      auto-complete="off"
                      @keyup.enter.native="login"
                    />
                    <el-button
                      :disabled="!dynamicCode.canClick"
                      :type="newWorld? 'danger' : 'primary'"
                      class="square-btn"
                      @click.native.prevent="sendCode"
                    >
                      {{dynamicCode.buttonText}}
                    </el-button>
                  </div>
                </el-form-item>
                <el-form-item v-if="activityList&&activityList.length">
                    <el-select v-model="currentActivity" style="width: 100%" @change="activityChange" placeholder="活动列表">
                      <el-option
                        v-for="item in activityList"
                        :key="item.id"
                        :label="item.activityName"
                        :value="item.id">
                      </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="isAgreement">
                  <div class="agreement">
                    <img class="agreement__icon pointer" :src="loginForm.isAgreement ? checkboxSelected : checkbox" @click="handleCheckbox" />
                    <div class="pointer" @click="onToAgreement">
                      我已阅读并同意<span class="link">《隐私权政策》</span>
                    </div>
                  </div>
                </el-form-item>
                <el-button
                  :loading="loading"
                  :type="newWorld? 'danger' : 'primary'"
                  class="green-btn"
                  style="width:100%;font-size: 18px"
                  @click.native.prevent="login"
                >
                  登 录
                </el-button>
              </div>

              <!--              钉钉登陆-->
              <div
                style="text-align: center"
                v-if="loginForm.loginType === 'dingtalk'"
              >
                <el-select
                  placeholder="请选择公司"
                  v-model="companyId"
                  v-if="activity.companies.length > 1"
                >
                  <el-option
                    v-for="company in activity.companies"
                    :key="company.id"
                    :label="company.name"
                    :value="company.id"
                  >
                  </el-option>
                </el-select>
                <div id="ddlogin-container">
                  二维码
                </div>
              </div>

            </div>
          </el-form>


          <div class="flex col text-center">
            <div>验证码可能会有2～3分钟的收件延迟请稍等；</div>
            <div>如未收到，可在第一次获取60s后重试；</div>
          </div>
          <div v-if="isShowFooter" class="login-form-footer">卡西欧官方商城 京ICP备 10009123号-10</div>
    <el-dialog
      width="80vw"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      top="35vh"
    >
      <div style="font-size: 16px;">
        <div class="agreement">
          <img class="agreement__icon pointer" :src="loginForm.isAgreement ? checkboxSelected : checkbox" @click="handleDialogCheckbox" />
          <div class="pointer">我已阅读并同意《隐私权政策》</div>
        </div>
        <div style="margin-top: 30px" @click="onToAgreement">请阅读最新<span class="link pointer">【卡西欧隐私权政策】</span></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import qs from 'qs'
const { mapState: activityMapState, mapMutations: activityMapMutations } = createNamespacedHelpers('activity')
const { mapState: authMapState, mapMutations: authMapMutations } = createNamespacedHelpers('auth')
import LoginFooter from './footer'
import config from '@/config'
import { Toast, Dialog  } from 'vant';
import { newWorld } from "@/helpers/index";

const dynamicCodeRule = [{ message: '请输入验证码', trigger: 'blur', required: true }]
const countTime = 60

export default {
  name: 'Login',
  components: {
    LoginFooter
  },
  data() {
    return {
      //邮箱登录
      loginForm: {
        loginType: 'email',
        email: '',
        dynamicCode: '',
        mobile: '',
        isAgreement: false
      },
      loginRules: {
        email: this.$formHelper.rules.emailRequired,
        dynamicCode: dynamicCodeRule,
        mobile: this.$formHelper.rules.phoneNumber,
        isAgreement: [{ validator:  (_, value, callback) => {
            if (!value && this.isValidatorAgreement) {
              callback('请阅读并勾选隐私权政策')
              return
            }
            callback()
          }, trigger: 'change'}]
      },
      dynamicCode: {
        'buttonText': '发送验证码',
        'totalTime': countTime,
        'canClick': true,
      },
      loading: false,
      redirectToName: undefined,
      companyId: undefined,
      logoUrl: config.siteLogo,
      backgroundUrl: config.loginBackground,
      isShowFooter: true,
      screenHeight: null,
      newWorld: newWorld(),
      currentActivity: undefined,
      checkbox: require('@/assets/icon/check-box.png'),
      checkboxSelected: require('@/assets/icon/check-box-selected.png'),
      isValidatorAgreement: true,
      dialogVisible: false
    }
  },
  computed: {
    ...activityMapState([
      'activity'
    ]),
    ...authMapState([
      'activityList'
    ]),
    // loginMethod() {
    //   if (this.activity) {
    //     return this.activity.loginMethod
    //   } else {
    //     return 'email'
    //   }
    // },
    loginMethodName() {
      const names = {
        mobile: '企业员工手机号登录',
        email: '邮箱登录',
      }
      return names[this.loginForm.loginType]
    }
  },
  mounted() {
    this.dialogVisible = true
    this.screenHeight = document.body.offsetHeight
    if (!this.activity) {
      // this.$alert('登录链接已过期，请从活动地址从新进入系统')
      // Dialog.alert({
      //   title: '',
      //   message: '登录链接已过期，请从活动地址从新进入系统',
      // }).then(() => {
      //   // on close
      //   this.$router.replace({ name: '404' })
      // });
    } else {
      // let loginMethod = this.activity.loginMethod.split(',').filter(item => item !== '')
      // this.loginForm.loginType = loginMethod?loginMethod.length>1 ? 'email':loginMethod[0]:'email'
      const company = this.activity.companies[0]
      if (company) {
        this.companyId = company.id
      }
      this.company = this.activity.companies[0]
      this.$store.dispatch('activity/setId', this.activity.id)
      this.$store.commit('cart/initCart', this.activity.id)
    }
    window.onresize = () => {
      let nowHeight = document.body.offsetHeight
      if (nowHeight < this.screenHeight) {
        this.isShowFooter = false
      } else {
        this.isShowFooter = true
      }
    }
  },
  destroyed() {
    window.onresize = null
  },
  watch: {
    companyId() {
      if (this.loginForm.loginType === 'dingtalk') {
        this.initDingTalkLogin()
      }
    },
    $route: {
      handler: function (route) {
        this.redirectToName = route.query && route.query.redirectToName
      },
      immediate: true
    }
  },
  methods: {
     ...authMapMutations(['setActiveList']),
     ...activityMapMutations(['setActivity']),
    async inputChange() {
      let account = ''
      if (this.loginForm.loginType === 'email') {
        let reg = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/
        account = reg.test(this.loginForm.email) ? this.loginForm.email : ''
      }
      if (this.loginForm.loginType === 'mobile') {
        account = /^1[345789]\d{9}$/.test(this.loginForm.mobile) ? this.loginForm.mobile : ''
      }
      if (account) {
        await this.$store.dispatch('auth/queryActivity', {account})
        this.currentActivity = this.activityList.length? this.currentActivity ? this.currentActivity : this.activityList[0].id : undefined
        await this.activityChange()
      } else {
        this.setActiveList([])
        this.setActivity({ activityId: null, activity: null })
      }
    },
    changeType(type) {
      const isAgreement = this.loginForm.isAgreement
      this.$refs.loginForm.resetFields()
      this.loginForm.loginType = type
      this.loginForm.isAgreement = isAgreement
      this.setActiveList([])
      this.currentActivity = undefined
    },
    async activityChange(value) {
      if (this.currentActivity) {
        await this.$store.dispatch('activity/setId', this.currentActivity)
      } else {
        this.setActivity({ activityId: null, activity: null })
      }
    },
    initDingTalkLogin() {

      window.removeEventListener('message', this.handleDingtalkMessage, false);

      const gotoUrl = this.getDingtalkGotoUrl()

      const obj = DDLogin({
        id: "ddlogin-container",
        goto: encodeURIComponent(gotoUrl),
        style: "border:none;background-color:#d9ebf8;margin-left:-30px;margin-top:-25px;",
        width: "365",
        height: "265"
      })
      window.addEventListener('message', this.handleDingtalkMessage, false);
    },
    handleDingtalkMessage(event) {
      const gotoUrl = this.getDingtalkGotoUrl()
      const origin = event.origin
      if (origin === "https://login.dingtalk.com") { //判断是否来自ddLogin扫码事件。
        const loginTmpCode = event.data; //拿到loginTmpCode后就可以在这里构造跳转链接进行跳转了
        const authorizeUrl = `${gotoUrl}&loginTmpCode=${loginTmpCode}`
        window.location.href = authorizeUrl
      }
    },
    getDingtalkGotoUrl() {
      const authorizeUri = 'https://oapi.dingtalk.com/connect/oauth2/sns_authorize'
      const companies = this.activity.companies
      const company = companies.find(company => company.id == this.companyId)
      const companyDingtalk = company.dingtalkConfig

      const redirectUri = `${this.$config.client.web.baseUrl}/ddcallback/${company.id}`;
      const config = this.$config.dingtalk

      const gotoParams = {
        appid: companyDingtalk.oauthAppId,
        response_type: 'code',
        scope: 'snsapi_login',
        state: 'STATE',
        redirect_uri: redirectUri,
      }
      return `${authorizeUri}?${qs.stringify(gotoParams)}`
    },
    async login() {
      this.isValidatorAgreement = true
      this.loginRules.dynamicCode = dynamicCodeRule
      await this.$formHelper.promisedValidate(this.$refs.loginForm)
      await this.inputChange()
      let type = 'auth/login'
      if (this.loginForm.loginType == 'mobile') {
        type = 'auth/mobileLogin'
      } else if (this.loginForm.loginType == 'email') {
        type = 'auth/login'
      }
      try {
        this.loading = true
        await this.$store.dispatch(type, this.loginForm)
        let pathName = ''
        if (this.redirectToName) {
          pathName = this.redirectToName
        } else if (this.activity.homeShow) {
          pathName = 'home'
        } else {
          pathName = 'list'
        }
        const userStorage = localStorage.getItem('user')
        if (userStorage) {
          const user = JSON.parse(userStorage)
          ysf('config', {
            uid: user.id,
            name: user.name
          })
        }
        this.$router.push({ name: pathName })
      } finally {
        this.loading = false
      }
    },
    async sendCode() {
      this.isValidatorAgreement = false
      const loginForm = this.$refs.loginForm
      loginForm.clearValidate()
      this.loginRules.dynamicCode = null
      await this.$formHelper.promisedValidate(loginForm)

      const { email, mobile, loginType } = this.loginForm
      if (!email && loginType == 'email') {
        // this.$message.error('请输入您的企业邮箱')
        Toast('请输入您的企业邮箱');
        return
      }
      if (!mobile && loginType == 'mobile') {
        // this.$message.error('请输入您的手机号码')
        Toast('请输入您的手机号码');
        return
      }
      await this.inputChange()
      let type = ''
      let payload = {}
      let msg = ''
      if (loginType == 'mobile') {
        type = 'code/mobileSend'
        payload = { mobile }
        msg = `验证码已发送到您的${mobile}手机号请查收，可能会有2～3分钟的收件延迟请稍等；如未收到，可在第一次获取60s后重试；`
      } else {
        type = 'code/send'
        payload = { email }
        msg = `验证码已发送到您的${email}邮箱请查收，可能会有2～3分钟的收件延迟请稍等；如未收到，可在第一次获取60s后重试；`
      }
      try {

        this.dynamicCode.canClick = false

        await this.$store.dispatch(type, payload)
      } finally {
        this.dynamicCode.canClick = true
      }
      this.countDown()
      this.confirm(msg, '提示', {
        showCancelButton: false
      })
    },
    countDown() {
      if (!this.dynamicCode.canClick) return
      this.dynamicCode.canClick = false
      this.dynamicCode.buttonText = this.dynamicCode.totalTime + 's后重新发送'
      let clock = window.setInterval(() => {
        this.dynamicCode.totalTime--
        this.dynamicCode.buttonText = this.dynamicCode.totalTime + 's后重新发送'
        if (this.dynamicCode.totalTime < 0) {
          window.clearInterval(clock)
          this.dynamicCode.buttonText = '重新发送验证码'
          this.dynamicCode.totalTime = countTime
          this.dynamicCode.canClick = true   //这里重新开启
        }
      }, 1000)
    },
    onToAgreement() {
      this.$router.push({ name: 'agreement' , params: { name: 'privacy' } });
    },
    handleCheckbox() {
      this.loginForm.isAgreement = !this.loginForm.isAgreement
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleDialogCheckbox() {
      this.dialogVisible = false
      this.handleCheckbox()
    },
  }
}
</script>
